import i18n from "@/common/i18n";
import { nanoid } from 'nanoid';
import privacyConifg from './components/PrivacyCard/config';
import imageConfig from './components/ImageProblem/config';
let filedJson = {
  radio: {
    label: `${i18n.t("lang.k_376001")}`,
    maxlength: 130,
    required: true,
    reporType: 100160,
    bottomBtn: ['addBtn', 'addOther', 'delete', 'move', 'requireSwtich'],
    type: 'radio',
    value: '',
    nodes: [{
      props: {},
      value: '',
      children: [{
        item_id: 0,
        other: false,
        question_id: 0,
        type: 0,
        value: `${i18n.t("lang.k_376002")}`,
        placeholder: `${i18n.t("lang.k_376002")}`
      }, {
        item_id: 0,
        other: false,
        question_id: 0,
        type: 0,
        value: `${i18n.t("lang.k_376002")}`,
        placeholder: `${i18n.t("lang.k_376002")}`
      }]
    }],
    reqType: 2,
    default_type: ''
  },
  checkBox: {
    label: `${i18n.t("lang.k_376003")}`,
    required: true,
    bottomBtn: ['addBtn', 'addOther', 'delete', 'move', 'requireSwtich'],
    type: 'checkBox',
    reporType: 100166,
    value: '',
    maxlength: 130,
    minRequired: 0,
    maxRequired: 0,
    nodes: [{
      props: {},
      value: [],
      children: [{
        item_id: 0,
        question_id: 0,
        type: 0,
        value: `${i18n.t("lang.k_376002")}`,
        placeholder: `${i18n.t("lang.k_376002")}`
      }, {
        item_id: 0,
        question_id: 0,
        type: 0,
        value: `${i18n.t("lang.k_376002")}`,
        placeholder: `${i18n.t("lang.k_376002")}`
      }]
    }],
    reqType: 3,
    default_type: ''
  },
  select: {
    label: `${i18n.t("lang.k_376004")}`,
    required: true,
    bottomBtn: ['addBtn', 'delete', 'move', 'requireSwtich'],
    type: 'select',
    reporType: 100176,
    value: '',
    nodes: [{
      props: {
        maxlength: 100,
        'show-word-limit': true,
        placeholder: `${i18n.t("lang.k_376002")}`,
        class: ['selectInput']
      },
      canRemove: true,
      value: '',
      item_id: 0,
      question_id: 0,
      type: 0,
      value: `${i18n.t("lang.k_376002")}`
    }, {
      props: {
        maxlength: 100,
        'show-word-limit': true,
        placeholder: `${i18n.t("lang.k_376002")}`,
        class: ['selectInput']
      },
      canRemove: true,
      value: '',
      item_id: 0,
      question_id: 0,
      type: 0,
      value: `${i18n.t("lang.k_376002")}`
    }],
    reqType: 4,
    default_type: '',
    placeholder: `${i18n.t("lang.k_376002")}`
  },
  select2: {
    label: `${i18n.t("lang.k_376005")}`,
    required: true,
    bottomBtn: ['addBtn', 'delete', 'move', 'requireSwtich'],
    type: 'select2',
    minRequired: 0,
    maxRequired: 0,
    reporType: 100176,
    value: '',
    nodes: [{
      props: {
        maxlength: 100,
        'show-word-limit': true,
        placeholder: `${i18n.t("lang.k_376002")}`,
        class: ['selectInput']
      },
      canRemove: true,
      value: '',
      item_id: 0,
      question_id: 0,
      type: 0,
      value: `${i18n.t("lang.k_376002")}`
    }, {
      props: {
        maxlength: 100,
        'show-word-limit': true,
        placeholder: `${i18n.t("lang.k_376002")}`,
        class: ['selectInput']
      },
      canRemove: true,
      value: '',
      item_id: 0,
      question_id: 0,
      type: 0,
      value: `${i18n.t("lang.k_376002")}`
    }],
    reqType: 8,
    default_type: '',
    placeholder: `${i18n.t("lang.k_376002")}`
  },
  input: {
    label: `${i18n.t("lang.k_376006")}`,
    required: true,
    reporType: 100172,
    bottomBtn: ['delete', 'move', 'requireSwtich'],
    type: 'input',
    value: '',
    nodes: [{
      props: {
        placeholder: `${i18n.t("lang.k_376007")}`
      },
      value: `${i18n.t("lang.k_376007")}`
    }],
    reqType: 1,
    default_type: '',
    disabledEdit: false
  },
  inputs: {
    label: `${i18n.t("lang.k_376008")}`,
    required: false,
    bottomBtn: ['delete', 'move', 'requireSwtich'],
    type: 'input',
    value: '',
    nodes: [{
      props: {
        placeholder: `${i18n.t("lang.k_376009")}`
      },
      value: ''
    }]
  },
  webinars: {
    label: `${i18n.t("lang.k_376010")}`,
    maxlength: 100,
    required: true,
    reporType: 0,
    bottomBtn: ['move'],
    type: 'webinars',
    placeholder: `${i18n.t("lang.k_376011")}`,
    value: '',
    nodes: [{
      props: {
        placeholder: `${i18n.t("lang.k_376010")}`
      },
      value: ''
    }],
    reqType: 7,
    default_type: '',
    disabledEdit: true
  }
};
const types = ['', '', 'radio', 'checkBox', 'select', '', ''];
export const basePreset = {
  //中文
  zh: {
    title: {
      placeholder: `${i18n.t("lang.k_376012")}`
    },
    intro: {
      placeholder: `${i18n.t("lang.k_376013")}`
    }
  },
  // 英文
  en: {
    title: {
      placeholder: `${i18n.t("lang.k_376014")}`
    },
    intro: {
      placeholder: `${i18n.t("lang.k_376015")}`
    }
  }
};
const filedPreset = {
  //中文
  zh: {
    name: {
      placeholder: `${i18n.t("lang.k_376016")}`,
      value: `${i18n.t("lang.k_376016")}`,
      label: `${i18n.t("lang.k_376017")}`
    },
    phone: {
      placeholder: `${i18n.t("lang.k_376018")}`,
      value: `${i18n.t("lang.k_376018")}`,
      label: `${i18n.t("lang.k_376019")}`
    },
    birthday: {
      placeholder: `${i18n.t("lang.k_376020")}`,
      label: `${i18n.t("lang.k_376021")}`
    },
    gender: {
      label: `${i18n.t("lang.k_376022")}`,
      children: [`${i18n.t("lang.k_376023")}`, `${i18n.t("lang.k_376024")}`]
    },
    email: {
      placeholder: `${i18n.t("lang.k_376025")}`,
      value: `${i18n.t("lang.k_376025")}`,
      label: `${i18n.t("lang.k_376026")}`
    },
    company: {
      placeholder: `${i18n.t("lang.k_376027")}`,
      value: `${i18n.t("lang.k_376027")}`,
      label: `${i18n.t("lang.k_376028")}`
    },
    regional: {
      label: `${i18n.t("lang.k_376029")}`,
      nodeOptions: [`${i18n.t("lang.k_376030")}`, `${i18n.t("lang.k_376031")}`, `${i18n.t("lang.k_376032")}`]
    },
    privacy: {
      content: {
        placeholder: `${i18n.t("lang.k_376033")}`,
        value: `${i18n.t("lang.k_376033")}`
      },
      color_text: {
        placeholder: `${i18n.t("lang.k_376034")}`,
        value: `${i18n.t("lang.k_376035")}`
      }
    }
  },
  // 英文
  en: {
    name: {
      placeholder: `${i18n.t("lang.k_376036")}`,
      value: 'Enter your name',
      label: 'Name'
    },
    phone: {
      placeholder: `${i18n.t("lang.k_376036")}`,
      value: 'Enter your phone number',
      label: 'Phone'
    },
    birthday: {
      placeholder: `${i18n.t("lang.k_376036")}`,
      label: 'Birthday'
    },
    gender: {
      label: 'Gender',
      children: ['Male', 'Female']
    },
    email: {
      placeholder: `${i18n.t("lang.k_376036")}`,
      value: 'Enter your email',
      label: 'Email'
    },
    company: {
      placeholder: `${i18n.t("lang.k_376036")}`,
      value: 'The company you work for',
      label: 'Company'
    },
    regional: {
      label: 'Region',
      nodeOptions: ['Province', 'City', 'District']
    }
  }
};
export function getfiledJson({
  name,
  type,
  defaultQaInfo,
  lang = 'zh'
}) {
  let json = '';
  let i = 0;
  let t = 0;
  let nodes = {};
  if (name) {
    switch (name) {
      case 'name':
        json = JSON.parse(JSON.stringify(filedJson['input']));
        json.nodes[0].props.placeholder = filedPreset[lang][name].placeholder;
        json.nodes[0].value = filedPreset[lang][name].value;
        json = Object.assign(json, {
          label: filedPreset[lang][name].label,
          required: true,
          bottomBtn: ['move'],
          reqType: 0,
          default_type: 1,
          subject: `${i18n.t("lang.k_376017")}`,
          disabledEdit: false
        });
        break;
      case 'phone':
        json = JSON.parse(JSON.stringify(filedJson['input']));
        json.nodes[0].props.placeholder = filedPreset[lang][name].placeholder;
        json.nodes[0].value = filedPreset[lang][name].value;
        json = Object.assign(json, {
          label: filedPreset[lang][name].label,
          required: true,
          bottomBtn: ['delete', 'move', 'requireSwtich', 'phoneValid'],
          reqType: 0,
          default_type: 2,
          subject: `${i18n.t("lang.k_376019")}`,
          phoneValide: true,
          abroadPhoneValide: false,
          disabledEdit: false
        });
        break;
      case 'birthday':
        json = JSON.parse(JSON.stringify(filedJson['input']));
        json.nodes[0].props.placeholder = filedPreset[lang][name].placeholder;
        json = Object.assign(json, {
          label: filedPreset[lang][name].label,
          required: true,
          bottomBtn: ['move', 'phoneValid'],
          disabledEdit: false
        });
        break;
      case 'gender':
        json = JSON.parse(JSON.stringify(filedJson['radio']));
        json.nodes[0].children[0].value = filedPreset[lang][name].children[0];
        json.nodes[0].children[1].value = filedPreset[lang][name].children[1];
        json.maxlength = 100;
        json = Object.assign(json, {
          label: filedPreset[lang][name].label,
          reporType: 100140,
          required: true,
          bottomBtn: ['delete', 'move', 'requireSwtich'],
          reqType: 0,
          default_type: 4,
          subject: `${i18n.t("lang.k_376022")}`
        });
        break;
      case 'email':
        json = JSON.parse(JSON.stringify(filedJson['input']));
        json.nodes[0].props.placeholder = filedPreset[lang][name].placeholder;
        json.nodes[0].value = filedPreset[lang][name].value;
        json = Object.assign(json, {
          label: filedPreset[lang][name].label,
          required: true,
          reqType: 0,
          reporType: 100144,
          bottomBtn: ['delete', 'move', 'requireSwtich', 'emailValid'],
          default_type: 3,
          subject: `${i18n.t("lang.k_376026")}`,
          emailValide: false,
          disabledEdit: false
        });
        break;

      // 公司
      case 'company':
        json = JSON.parse(JSON.stringify(filedJson['input']));
        json.nodes[0].props.placeholder = filedPreset[lang][name].placeholder;
        json.nodes[0].value = filedPreset[lang][name].value;
        json = Object.assign(json, {
          label: filedPreset[lang][name].label,
          required: true,
          reporType: 100152,
          bottomBtn: ['delete', 'move', 'requireSwtich'],
          default_type: 9,
          options: {
            type: 7
          },
          disabledEdit: false
        });
        break;

      // 行业
      case 'industry':
        t = type || defaultQaInfo.field_type || 4;
        i = types[t];
        json = JSON.parse(JSON.stringify(filedJson[i])); //select

        nodes = {};
        if (t == 4) {
          //下拉框
          nodes = defaultQaInfo.field_options.map(item => {
            return {
              props: {
                placeholder: '',
                class: ['selectInput']
              },
              canRemove: true,
              value: lang === 'en' ? item.option_names_en?.option_name : item.option_names_zh?.option_name,
              item_id: 0,
              question_id: 0,
              type: 0,
              general_option_key: item.option_key
            };
          });
        } else {
          //单选多选
          let cl = defaultQaInfo.field_options.map(item => {
            return {
              props: {
                placeholder: '',
                class: []
              },
              canRemove: true,
              value: lang === 'en' ? item.option_names_en?.option_name : item.option_names_zh?.option_name,
              item_id: 0,
              question_id: 0,
              type: 0,
              general_option_key: item.option_key
            };
          });
          nodes = [{
            props: {},
            value: [],
            children: cl
          }];
        }
        json = Object.assign(json, {
          label: lang === 'en' ? defaultQaInfo.field_names_en?.field_name || 'Industry' : defaultQaInfo.field_names_zh?.field_name || `${i18n.t("lang.k_376037")}`,
          required: true,
          general_field_key: defaultQaInfo.field_key,
          //通用字段KEY
          system_type: 11,
          disabledEdit: true,
          bottomBtn: ['delete', 'move', 'requireSwtich', 'choseOption'],
          default_type: 11,
          nodes: nodes,
          options: {
            question_subject: lang === 'en' ? defaultQaInfo.field_names_en?.field_name || 'Industry' : defaultQaInfo.field_names_zh?.field_name || `${i18n.t("lang.k_376037")}`,
            general_field_options: defaultQaInfo.field_options
          }
        });
        break;

      // 地域
      case 'regional':
        json = JSON.parse(JSON.stringify(filedJson['select']));
        json = Object.assign(json, {
          label: filedPreset[lang][name].label,
          required: true,
          bottomBtn: ['delete', 'move', 'requireSwtich'],
          nodes: filedPreset[lang][name].nodeOptions.map((item, index) => {
            return {
              props: {
                disabled: true,
                placeholder: item,
                class: ['selectInput', 'regionalInput']
              },
              value: '',
              index
            };
          }),
          reqType: 5,
          reporType: 100148,
          default_type: 5,
          options: {
            show_country: 1,
            show_province: 1,
            show_city: 1,
            show_district: 1
          },
          disabledEdit: true
        });
        break;

      // 职务
      case 'duty':
        t = type || defaultQaInfo.field_type || 3;
        i = types[t];
        json = JSON.parse(JSON.stringify(filedJson[i])); //checkBox

        nodes = {};
        if (t == 4) {
          //下拉框
          nodes = defaultQaInfo.field_options.map(item => {
            return {
              props: {
                placeholder: '',
                class: ['selectInput']
              },
              canRemove: true,
              value: lang === 'en' ? item.option_names_en?.option_name : item.option_names_zh?.option_name,
              item_id: 0,
              question_id: 0,
              type: 0,
              general_option_key: item.option_key
            };
          });
        } else {
          //单选多选
          let cl = defaultQaInfo.field_options.map(item => {
            return {
              props: {
                placeholder: '',
                class: []
              },
              canRemove: true,
              value: lang === 'en' ? item.option_names_en?.option_name : item.option_names_zh?.option_name,
              item_id: 0,
              question_id: 0,
              type: 0,
              general_option_key: item.option_key
            };
          });
          nodes = [{
            props: {},
            value: [],
            children: cl
          }];
        }
        json = Object.assign(json, {
          label: lang === 'en' ? defaultQaInfo.field_names_en?.field_name || 'Post' : defaultQaInfo.field_names_zh?.field_name || `${i18n.t("lang.k_376038")}`,
          required: true,
          general_field_key: defaultQaInfo.field_key,
          //通用字段KEY
          reporType: 100156,
          system_type: 12,
          disabledEdit: true,
          bottomBtn: ['delete', 'move', 'requireSwtich', 'choseOption'],
          default_type: 12,
          nodes: nodes,
          options: {
            question_subject: lang === 'en' ? defaultQaInfo.field_names_en?.field_name || 'Post' : defaultQaInfo.field_names_zh?.field_name || `${i18n.t("lang.k_376038")}`,
            general_field_options: defaultQaInfo.field_options
          }
        });
        break;
      //职务（旧）
      case 'duty_old':
        json = JSON.parse(JSON.stringify(filedJson['select']));
        json = Object.assign(json, {
          label: `${i18n.t("lang.k_376038")}`,
          required: true,
          reporType: 100156,
          system_type: 8,
          default_type: 8,
          nodes: [`${i18n.t("lang.k_376039")}`, `${i18n.t("lang.k_376040")}`, `${i18n.t("lang.k_376041")}`, `${i18n.t("lang.k_376042")}`, `${i18n.t("lang.k_376043")}`, `${i18n.t("lang.k_376044")}`, `${i18n.t("lang.k_376045")}`].map(item => {
            return {
              props: {
                placeholder: `${i18n.t("lang.k_376002")}`,
                class: ['selectInput']
              },
              canRemove: true,
              value: item,
              item_id: 0,
              question_id: 0,
              type: 0
            };
          }),
          options: {
            item_list: [`${i18n.t("lang.k_376039")}`, `${i18n.t("lang.k_376040")}`, `${i18n.t("lang.k_376041")}`, `${i18n.t("lang.k_376042")}`, `${i18n.t("lang.k_376043")}`, `${i18n.t("lang.k_376044")}`, `${i18n.t("lang.k_376045")}`],
            question_subject: `${i18n.t("lang.k_376038")}`,
            immutable: true
          }
        });
        break;
      // 职位
      case 'position':
        t = type || defaultQaInfo.field_type || 2;
        i = types[t];
        json = JSON.parse(JSON.stringify(filedJson[i])); //radio

        nodes = {};
        if (t == 4) {
          //下拉框
          nodes = defaultQaInfo.field_options.map(item => {
            return {
              props: {
                placeholder: '',
                class: ['selectInput']
              },
              canRemove: true,
              value: lang === 'en' ? item.option_names_en?.option_name : item.option_names_zh?.option_name,
              item_id: 0,
              question_id: 0,
              type: 0,
              general_option_key: item.option_key
            };
          });
        } else {
          //单选多选
          let cl = defaultQaInfo.field_options.map(item => {
            return {
              props: {
                placeholder: '',
                class: []
              },
              canRemove: true,
              value: lang === 'en' ? item.option_names_en?.option_name : item.option_names_zh?.option_name,
              item_id: 0,
              question_id: 0,
              type: 0,
              general_option_key: item.option_key
            };
          });
          nodes = [{
            props: {},
            value: [],
            children: cl
          }];
        }
        json = Object.assign(json, {
          label: lang === 'en' ? defaultQaInfo.field_names_en?.field_name || 'Position' : defaultQaInfo.field_names_zh?.field_name || `${i18n.t("lang.k_376046")}`,
          required: true,
          general_field_key: defaultQaInfo.field_key,
          //通用字段KEY
          system_type: 10,
          disabledEdit: true,
          bottomBtn: ['delete', 'move', 'requireSwtich', 'choseOption'],
          default_type: 10,
          nodes: nodes,
          options: {
            question_subject: lang === 'en' ? defaultQaInfo.field_names_en?.field_name || 'Position' : defaultQaInfo.field_names_zh?.field_name || `${i18n.t("lang.k_376046")}`,
            general_field_options: defaultQaInfo.field_options
          }
        });
        break;
      case 'educational':
        json = JSON.parse(JSON.stringify(filedJson['select']));
        json = Object.assign(json, {
          label: `${i18n.t("lang.k_376047")}`,
          required: true,
          // "bottomBtn": [,"delete", "move", "requireSwtich"],
          nodes: [`${i18n.t("lang.k_376048")}`, `${i18n.t("lang.k_376049")}`, `${i18n.t("lang.k_376050")}`, `${i18n.t("lang.k_376051")}`, `${i18n.t("lang.k_376045")}`].map(item => {
            return {
              props: {
                disabled: item != `${i18n.t("lang.k_376045")}`,
                placeholder: `${i18n.t("lang.k_376002")}`,
                class: ['selectInput']
              },
              canRemove: true,
              value: item
            };
          })
        });
        break;
      case 'privacy':
        json = privacyConifg.create(lang);
        break;

      // 图片收集
      case 'image':
        json = imageConfig.create(lang);
        break;
      default:
        break;
    }
    json.name = name;
  } else {
    json = JSON.parse(JSON.stringify(filedJson[type]));
    json.labelEditable = true;
    switch (type) {
      // 单选题/多选题
      case 'radio':
      case 'checkBox':
        {
          json.placeholder = lang === 'en' ? `${i18n.t("lang.k_376052")}` : `${i18n.t("lang.k_376002")}`;
          for (let ele of json.nodes[0].children) {
            ele.placeholder = lang === 'en' ? `${i18n.t("lang.k_376052")}` : `${i18n.t("lang.k_376002")}`;
            ele.value = lang === 'en' ? 'Options' : `${i18n.t("lang.k_376002")}`;
          }
        }
        break;
      // 下拉题(单选)
      case 'select':
        {
          json.placeholder = lang === 'en' ? `${i18n.t("lang.k_376052")}` : `${i18n.t("lang.k_376002")}`;
          for (let ele of json.nodes) {
            ele.props.placeholder = lang === 'en' ? `${i18n.t("lang.k_376052")}` : `${i18n.t("lang.k_376002")}`;
            ele.value = lang === 'en' ? 'Options' : `${i18n.t("lang.k_376002")}`;
          }
        }
        break;
      // 下拉题(多选)
      case 'select2':
        {
          json.placeholder = lang === 'en' ? `${i18n.t("lang.k_376052")}` : `${i18n.t("lang.k_376002")}`;
          for (let ele of json.nodes) {
            ele.props.placeholder = lang === 'en' ? `${i18n.t("lang.k_376052")}` : `${i18n.t("lang.k_376002")}`;
            ele.value = lang === 'en' ? 'Options' : `${i18n.t("lang.k_376002")}`;
          }
        }
        break;
      // 问答题
      case 'input':
        {
          json.label = lang === 'en' ? 'Q&A' : `${i18n.t("lang.k_376006")}`;
          json.placeholder = lang === 'en' ? 'Enter your answer' : `${i18n.t("lang.k_376007")}`;
          for (let ele of json.nodes) {
            ele.props.placeholder = lang === 'en' ? 'Enter your answer' : `${i18n.t("lang.k_376007")}`;
            ele.value = lang === 'en' ? '' : `${i18n.t("lang.k_376007")}`;
          }
        }
        break;
      case 'webinars':
        json.placeholder = lang === 'en' ? `${i18n.t("lang.k_376053")}` : `${i18n.t("lang.k_376011")}`;
        json.label = lang === 'en' ? 'Please select' : `${i18n.t("lang.k_376010")}`;
        json.nodes[0].props.placeholder = lang === 'en' ? `${i18n.t("lang.k_376036")}` : `${i18n.t("lang.k_376010")}`;
        break;
    }
  }
  return json;
}